import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/analisis-estrategico/estudio-factibilidad/EstudioFactibilidadClient.tsx");
